import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'completed':
        return {
          label: 'Completado',
          icon: 'CheckCircle',
          bgColor: 'bg-success/10',
          textColor: 'text-success',
          iconColor: 'text-success'
        };
      case 'failed':
        return {
          label: 'Fallido',
          icon: 'XCircle',
          bgColor: 'bg-error/10',
          textColor: 'text-error',
          iconColor: 'text-error'
        };
      case 'in-progress':
        return {
          label: 'En progreso',
          icon: 'Loader',
          bgColor: 'bg-warning/10',
          textColor: 'text-warning',
          iconColor: 'text-warning'
        };
      case 'cancelled':
        return {
          label: 'Cancelado',
          icon: 'Ban',
          bgColor: 'bg-muted',
          textColor: 'text-muted-foreground',
          iconColor: 'text-muted-foreground'
        };
      case 'partial':
        return {
          label: 'Parcial',
          icon: 'AlertTriangle',
          bgColor: 'bg-warning/10',
          textColor: 'text-warning',
          iconColor: 'text-warning'
        };
      default:
        return {
          label: 'Desconocido',
          icon: 'HelpCircle',
          bgColor: 'bg-muted',
          textColor: 'text-muted-foreground',
          iconColor: 'text-muted-foreground'
        };
    }
  };

  const config = getStatusConfig();
  const isSmall = size === 'sm';
  const iconSize = isSmall ? 12 : 16;
  const textSize = isSmall ? 'text-xs' : 'text-sm';
  const padding = isSmall ? 'px-2 py-1' : 'px-3 py-1.5';

  return (
    <span className={`inline-flex items-center space-x-1 ${padding} ${config?.bgColor} ${config?.textColor} rounded-full ${textSize} font-medium`}>
      <Icon 
        name={config?.icon} 
        size={iconSize} 
        className={`${config?.iconColor} ${status === 'in-progress' ? 'animate-spin' : ''}`}
      />
      <span>{config?.label}</span>
    </span>
  );
};

export default StatusBadge;